
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M20.042 1.442c10.272 0 18.6 8.328 18.6 18.6 0 10.272-8.328 18.6-18.6 18.6-10.273 0-18.6-8.328-18.6-18.6 0-10.272 8.327-18.6 18.6-18.6z","stroke":"#930012","stroke-dasharray":"3,2"}}),_c('path',{attrs:{"d":"M24.179 28.459c0 1.446-.91 1.872-2.03.951l-11.131-9.144c-.498-.41-.492-1.064.016-1.465l11.081-8.734c1.14-.899 2.064-.454 2.064.992v17.4z","fill":"#930012"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/tabs/network/Closure.svg